import 'vuetify/styles'

import { createVuetify } from 'vuetify'

import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

// UI SVG icons:
// https://www.flaticon.com/icon-fonts-most-downloaded?weight=thin&type=uicon

// https://pictogrammers.com/library/mdi/

import { mdiAccount, mdiArrowLeft, mdiArrowRightTop, mdiCameraOutline, mdiCheck,
    mdiCommentOutline, mdiDotsVertical, mdiEarth, mdiFile, mdiFileDocumentRemoveOutline,
    mdiFilePdfBox, mdiFilePresentationBox, mdiTrashCanOutline, mdiViewDashboard, mdiMapMarker, mdiVolumeOff,
    mdiFolder, mdiGoogleSpreadsheet, mdiHeadphonesBox, mdiHome, mdiImage, mdiInformationOutline, mdiLock,
    mdiLogin, mdiMapMarkerOutline, mdiMovie, mdiSecurity, mdiListBox, mdiAccountGroup,
    mdiFolderOutline, mdiChevronRight, mdiOpenInNew, mdiCommentQuote, mdiContentCopy, mdiPencilBoxOutline,
    mdiTextBox, mdiCash, mdiDrawingBox, mdiArrowULeftTop, mdiAccountArrowRight, mdiStopCircleOutline,
    mdiClipboardAccountOutline, mdiCircleMedium, mdiPowerSleep, mdiWhiteBalanceSunny,
    mdiEyeOutline, mdiEyeOffOutline, mdiHours12, mdiHours24, mdiNumeric3, mdiNumeric7,
    mdiCalendar,
    mdiMinusCircle, mdiPlusCircle, mdiRename,
    mdiPlusCircleOutline, mdiMinusCircleOutline, mdiFolderMoveOutline,
    mdiFormTextbox, mdiDeleteRestore, mdiFileEditOutline,
    mdiFolderAccount, mdiFolderKey,
    mdiZipBox, mdiGoogle, mdiBugOutline,
    mdiCrownOutline, mdiPower, mdiLink, mdiContentPaste, mdiPlusCircleMultipleOutline,
    mdiTuneVariant, mdiUpdate, mdiRefresh, mdiTagOutline,
    // mdiSync,
} from '@mdi/js'

// Styles
// import '@mdi/font/css/materialdesignicons.css'
// import '@material-symbols/font-400/outlined.css'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    theme: {
        defaultTheme: localStorage.getItem('theme') ?? 'system',
        themes: {
            light: {
                colors: {
                    'arc-watch': '#666666',
                    'arc-other': '#DDDDDD',
                },
            },
            dark: {
                colors: {
                    'arc-watch': '#EEEEEE',
                    'arc-other': '#666666',
                },
            },
        },
    },
    defaults: {
        VIcon: {
            variant: 'outlined',
        },
    },
    icons: {
        defaultSet: 'mdi',
        aliases: {
            ...aliases,
            folder: mdiFolder,
            folderOutline: mdiFolderOutline,
            pdf: mdiFilePdfBox,
            image: mdiImage,
            document: mdiTextBox,
            drawing: mdiDrawingBox,
            cash: mdiCash,
            spreadsheet: mdiGoogleSpreadsheet,
            presentation: mdiFilePresentationBox,
            archive: mdiZipBox,
            video: mdiMovie,
            file: mdiFile,
            text: mdiFile,
            site: mdiViewDashboard,
            map: mdiMapMarker,
            form: mdiListBox,
            shortcut: mdiArrowRightTop,
            check: mdiCheck,
            arrowleft: mdiArrowLeft,
            chevronRight: mdiChevronRight,
            commentOutline: mdiCommentOutline,
            home: mdiHome,
            globe: mdiEarth,
            lock: mdiLock,
            person: mdiAccount,
            security: mdiSecurity,
            location: mdiMapMarkerOutline,
            photoCamera: mdiCameraOutline,
            dotsVertical: mdiDotsVertical,
            audio: mdiHeadphonesBox,
            // sync: mdiSync,
            resetFolder: mdiFileDocumentRemoveOutline,
            info: mdiInformationOutline,
            login: mdiLogin,
            trash: mdiTrashCanOutline,
            mute: mdiVolumeOff,
            people: mdiAccountGroup,
            openInNew: mdiOpenInNew,
            quote: mdiCommentQuote,
            copy: mdiContentCopy,
            suggest: mdiPencilBoxOutline,
            reopen: mdiArrowULeftTop,
            reassign: mdiAccountArrowRight,
            assign: mdiClipboardAccountOutline,
            stop: mdiStopCircleOutline,
            hours12: mdiHours12,
            hours24: mdiHours24,
            numeric3: mdiNumeric3,
            numeric7: mdiNumeric7,
            circle: mdiCircleMedium,
            themeDark: mdiPowerSleep,
            themeLight: mdiWhiteBalanceSunny,
            eye: mdiEyeOutline,
            eyeOff: mdiEyeOffOutline,
            calendar: mdiCalendar,
            plusCircle: mdiPlusCircle,
            minusCircle: mdiMinusCircle,
            plusCircleOutline: mdiPlusCircleOutline,
            minusCircleOutline: mdiMinusCircleOutline,
            folderMoveOutline: mdiFolderMoveOutline,
            formTextbox: mdiFormTextbox,
            deleteRestore: mdiDeleteRestore,
            fileEditOutline: mdiFileEditOutline,
            rename: mdiRename,
            folderAccount: mdiFolderAccount,
            folderKey: mdiFolderKey,
            google: mdiGoogle,
            bug: mdiBugOutline,
            crown: mdiCrownOutline,
            power: mdiPower,
            link: mdiLink,
            paste: mdiContentPaste,
            plusMultiple: mdiPlusCircleMultipleOutline,
            settings: mdiTuneVariant,
            update: mdiUpdate,
            refresh: mdiRefresh,
            tag: mdiTagOutline,
        },
        sets: {
            mdi,
        },
    },
    // icons: {
    //     defaultSet: 'mds',
    //     aliases,
    //     sets: {
    //         // mat: mat('outlined'),
    //         mds,
    //         ff: ffSet,
    //         // mdi,
    //     },
    // },
})
